import { XMarkIcon } from '@heroicons/react/24/outline';

interface PatientChipProps {
    name: string;
    onRemove?: () => void;
    /** Grayed out, no remove button - `title` (native tooltip) explains why. */
    disabled?: boolean;
    title?: string;
}

// A small teal pill, used both in read-only patient lists and the Linked
// patients card's chip list (removable via onRemove). `disabled` swaps the
// teal for a quiet gray variant (e.g. AddPatientNoteModal's already-noted
// patients) - still shown, never removable.
export function PatientChip({ name, onRemove, disabled = false, title }: PatientChipProps) {
    return (
        <span
            title={title}
            className={`inline-flex items-center gap-1.5 rounded-full pl-2 pr-2 h-6 text-xs font-semibold whitespace-nowrap max-w-full ${
                disabled ? 'bg-gray-100 text-gray-400' : 'bg-[#CAF2ED] text-[#22615A]'
            }`}
        >
            <span
                className={`w-1.5 h-1.5 rounded-full shrink-0 ${disabled ? 'bg-gray-300' : 'bg-[#2C6F67]'}`}
            />
            <span className="truncate">{name}</span>
            {!disabled && onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    aria-label={`Unlink ${name}`}
                    className="opacity-60 hover:opacity-100 shrink-0"
                >
                    <XMarkIcon className="h-3 w-3" />
                </button>
            )}
        </span>
    );
}
